import { setUXLMigrationStatus, getUXLMigrationStatus } from './migrationHeader';
import { AppProps } from 'next/app';

export const setupGlobalFlags = ({ pageProps }: AppProps) => {
  const { isDTT, isNRP, isACRS, uxlMigrationStatus, propertyId, redemptionFeatureFlag } = pageProps;
  if (typeof window !== 'undefined') {
    window['dtt'] = isDTT;
    window['acrs'] = isACRS;
    window['nrp'] = isNRP;
    window['redemptionFeatureFlag'] = redemptionFeatureFlag;
    if (uxlMigrationStatus !== '' && !getUXLMigrationStatus(propertyId)) {
      const headers = new Headers();
      headers.append('uxl-migration-status', uxlMigrationStatus);
      setUXLMigrationStatus(headers, propertyId);
    }
  }
};
